import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

import { type IUserType } from "./UserTypes.types";

const mapTypes = (data: any) => data?.data?.content as { list: IUserType[] };

const UserTypes = () => {
  const { data, isLoading } = useGetApi({
    request: "get-management",
    body: { _sect: "_usertypes" },
    mapper: mapTypes,
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <ManagementTable
        section="_usertypes"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default UserTypes;
